import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Guia_Digital_Enviada } from 'generated/graphql';

const initialState: Guia_Digital_Enviada = null as any;

const guiasDigitalesStateSlice = createSlice({
	name: 'guiasDigitalesState',
	initialState,
	reducers: {
		setGuiasDigitalesState: (state, action: PayloadAction<Guia_Digital_Enviada>) => {
			return action.payload;
		}
	}
});

export const { setGuiasDigitalesState } = guiasDigitalesStateSlice.actions;

export default guiasDigitalesStateSlice.reducer;
